import $api from "../http";

export default class PaymentService {
  static async createAlatauPayment(orderNumber) {
    const res = await $api.post(
      "/api/payment/alatau/create",
      { orderNumber },
      {
        responseType: "text",
      },
    );

    return res.data; 
  }

  static async createKaspiPayment(orderNumber) {
    const res = await $api.post("/api/payment/kaspi/create", { orderNumber });

    return res.data;
  }

  static async getKaspiStatus(paymentId) {
    const res = await $api.get(`/api/payment/kaspi/status/${paymentId}`);

    return res.data;
  }

  static redirectToAlatau(html) {
    const w = window.open("", "_self");
    w.document.open();
    w.document.write(html);
    w.document.close();
  }

}
